import {Snippet} from '../../../../../Models/Snippet';
import {DownloadedIndoorWorkout} from '../../../../../Models/DownloadedIndoorWorkout';
import {Stroke} from '../../../../../Models/Stroke';
import {downloadedIndoorWorkoutToStrokes} from '../../../../../Strokes/downloadedIndoorWorkoutToStrokes';

export function strokesForSnippet(snippet: Snippet, downloadedIndoorWorkout: DownloadedIndoorWorkout): Stroke[] {
    const strokes = downloadedIndoorWorkoutToStrokes(downloadedIndoorWorkout);
    const start = strokes.findIndex((stroke: Stroke) => {
        return stroke.totalTime.gte(snippet.startTime);
    });
    const end =
        strokes.findLastIndex((stroke: Stroke) => {
            return stroke.totalTime.lte(snippet.endTime);
        }) + 1;

    return strokes.slice(start, end);
}
